/**
 * Gateway prefix for awards-service (deployed as `awards-service-api`), which
 * the ingress VirtualService rewrites to `/`. Member-facing routes live under
 * `/cycles` and address the caller from the JWT — no id segment, no `/me`
 * (`middleware.OfficeDelegation` rebinds to a child office via `x-office`,
 * which `getAuthHeaders()` already sends). Centralised so a prefix correction
 * is a single edit; confirm against dev on the first live call.
 */
export const AWARDS_API_PREFIX = '/awards-service-api';
